import { DistinctRecipesMoD } from '@/api/types'
import React, { useEffect, useRef } from 'react'
import * as Plot from '@observablehq/plot'

export default function MealOfDayDistinctRecipesChart({ data }: { data: DistinctRecipesMoD[] }) {
  const containerRef = useRef<HTMLDivElement>(null)

  const mealsDomain = [
    'BREAKFAST',
    'MIDDLE_MORNING',
    'LUNCH',
    'MIDDLE_AFTERNOON',
    'DINNER',
    'AFTER_DINNER',
  ]

  useEffect(() => {
    if (data === undefined) return
    const plot = Plot.plot({
      marks: [Plot.ruleY([0]), Plot.boxY(data, { x: 'mealOfDay', y: 'distinctRecipesPercentage' })],
      x: {
        label: 'Meal of day',
        type: 'band',
        domain: mealsDomain,
        tickValues: mealsDomain,
        grid: true,
      },
      y: {
        label: 'Distinct Recipes',
        grid: true,
      },
      color: {
        legend: true,
        scheme: 'category10',
      },
      marginLeft: 60,
      marginBottom: 60,
      width: 800,
      height: 500,
      title: 'Distinct Recipes per meal of day',
      legend: true,
    })

    if (containerRef?.current) {
      containerRef.current.append(plot)
    }

    return () => plot.remove()
  }, [data])

  return <div className="panel-xs" ref={containerRef} />
}
